export const billBasicsToc = [
  { id: "answer", label: "先に結論：合計額だけで比べない" },
  { id: "bill-parts", label: "スマホ代を4つに分ける" },
  { id: "screen-steps", label: "請求明細を確認する5ステップ" },
  { id: "example", label: "月8,000円の明細で見てみる" },
  { id: "review-order", label: "見直す順番と判断基準" },
  { id: "official-links", label: "通信会社別の確認ページ" },
  { id: "faq", label: "よくある疑問" },
  { id: "next-actions", label: "次の一歩" },
];
